<template>
  <div
    class="accordion-section critical-component-clear"
    :class="{
      'accordion-section__centered': liquid.alignment === 'center',
      'section-styles--top-padding': liquid.topPadding,
      'section-styles--bottom-padding': liquid.bottomPadding,
      'section-styles--divider': liquid.sectionDividers,
    }"
  >
    <div class="container grid">
      <div class="col xs6 l4-9">
        <div
          v-if="liquid.title || liquid.description"
          class="accordion-section__header"
        >
          <h2
            v-if="liquid.title"
            :id="`section-title-${liquid.sectionId}`"
            class="
              accordion-section__header-title
              text-heading-s
              text-heading-m-desktop
            "
            v-text="liquid.title"
          />

          <p
            v-if="liquid.description"
            class="
              accordion-section__header-content
              text-body-xs
              text-body-s-desktop
            "
            v-text="liquid.description"
          />
        </div>

        <div
          v-if="panels.length"
          class="accordion-section__panels-container"
        >
          <dynamic-accordion
            class="accordion-section__panels"
            heading-type="h2"
            :panel-data="panels"
          />
        </div>

        <div
          v-if="liquid.ctaLink && liquid.ctaText"
          class="accordion-section__footer"
        >
          <a
            class="button button--text"
            :href="liquid.ctaLink"
          >
            <span
              class="button__label button__label--no-icon"
              v-text="liquid.ctaText"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Accordion (accordion-section)
 * -----------------------------------------------------------------------------
 * Text section with accordions to condense longer form information.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 *
 */
import DynamicAccordion from '~async/dynamic-accordion/dynamic-accordion'

export default {
  name: 'AccordionSection',

  components: {
    DynamicAccordion,
  },

  props: {
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
        title: '',
        description: '',
        ctaLink: '',
        ctaText: '',
        alignment: '',
        bottomPadding: '',
        topPadding: '',
        sectionDividers: '',
      }),
    },
    panels: {
      type: Array,
      default: () => [
        {
          title: '',
          content: '',
          classes: {
            title: 'accordion-section__panel-title text-body-s',
            content: 'accordion-section__panel-content text-body-s rte',
          },
        },
      ],
    },
  },

}
</script>

<style lang="scss">
@import './accordion-section';
</style>
